$(document).on('render:stats', () => {
  document.querySelector('.back_btn').style.display = 'flex'
})
